import { useState, useEffect } from 'react';
import Button from 'components/ui-components/Button';

import { Arrow, CloseXmark } from 'assets/icons';
import { white, cefRed } from 'constants/variables';
import useProductCompare from 'hooks/productCompare/useProductCompare';

const ProductCompare = ({ url, num_products }) => {
  const [numProducts, setNumProducts] = useState(num_products || 1);
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const { response, setConfig } = useProductCompare();

  useEffect(() => {
    PubSub.subscribe('PRODUCT-COMPARE-ADDED', () => {
      getCompareProducts();
    });
  }, []);

  useEffect(() => {
    PubSub.publish('PRODUCT-COMPARE-UPDATED', products);

    if (numProducts === 0) {
      setOpen(false);
    }
  }, [products]);

  useEffect(() => {
    if (open) {
      getCompareProducts();
    }
  }, [open]);

  useEffect(() => {
    if (response.result) {
      const { success, data, updateProducts } = response.result;
      if (success && updateProducts) {
        setProducts(data);
        setError(false);
        setNumProducts(data.length);
        setConfig(null);
      } else if (success) {
        setConfig(null);
        getCompareProducts();
      } else {
        setConfig(null);
        setError(true);
      }
    }
  }, [response.result]);

  const clearAllCompareProducts = () => {
    removeCompareProduct();
  };

  const viewCompareProducts = () => {
    if (products.length > 1) {
      const newUrl = `${url}?products=${products
        .map(prod => prod.id)
        .join(',')}`;
      location.href = newUrl;
    }
  };

  const viewProduct = product_url => {
    location.href = product_url;
  };

  const removeCompareProduct = product => {
    setConfig({
      method: 'DELETE',
      url: '/products_compare',
      params: { product_id: product },
    });
  };

  const getCompareProducts = () => {
    setConfig({ method: 'GET', url: '/products_compare', params: {} });
  };

  return (
    <div
      className={`product-compare__bar hidden-phone ${
        numProducts > 0 ? 'active' : ''
      }${open ? ' open' : ''}`}>
      <div className="v2-container">
        <div className="fl compare-bar__info">
          <Button
            className={`compare ${products.length < 2 ? 'inactive' : ''}`}
            handleClick={viewCompareProducts}>
            Compare Products ({numProducts})
            <Arrow fillColor={white} />
          </Button>

          <button className="clear-all" onClick={clearAllCompareProducts}>
            Clear All
          </button>
          <Button
            bgColour={white}
            className="toggle-compare"
            handleClick={() => {
              setOpen(!open);
            }}>
            {open ? 'Close' : 'Open'}
            <Arrow fillColor={white} direction={open ? 'down' : 'up'} />
          </Button>
        </div>
        <div className="fl row compare-products">
          {products.map(
            ({ id, image, url, catalogue, description, stock_code }, index) => (
              <div className="product-compare__items" key={index}>
                <div className="product--preview">
                  <Button
                    className="product-compare__close"
                    type="button"
                    bgColour={white}
                    handleClick={() => {
                      removeCompareProduct(id);
                    }}
                    label="remove icon">
                    <CloseXmark
                      mainFillColor={cefRed}
                      strokeColor={cefRed}
                      height={24}
                      width={24}
                    />
                  </Button>
                  <div
                    className="product-image"
                    onClick={() => {
                      viewProduct(url);
                    }}>
                    <img src={image} aria-label="product image" />
                  </div>
                  <div
                    className="product-detail"
                    onClick={() => {
                      viewProduct(url);
                    }}>
                    <h4>{description}</h4>
                    Part Code: <strong>{catalogue}</strong>
                    <br />
                    Stock Code: <strong>{stock_code}</strong>
                  </div>
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCompare;
